import { UseQueryOptions } from '@tanstack/react-query';

import { CuredApiPaths } from 'models/enums';
import { InconnectTemplatesResponse } from 'models/types';

import useQuery from '../useQuery';

import QueryKeys from './keys';

type Params = { offset?: number; name?: string };

const useInconnectTemplates = (
    params: Params = {},
    reactQueryOptions?: UseQueryOptions<InconnectTemplatesResponse, Error>
) => {
    const { offset, name } = params;
    const qs = [
        'channel=email',
        offset !== undefined ? `offset=${offset}` : undefined,
        name ? `name=${encodeURIComponent(name)}` : undefined,
    ]
        .filter(Boolean)
        .join('&');
    return useQuery<InconnectTemplatesResponse>(
        QueryKeys.INCONNECT_TEMPLATES(offset, name),
        `${CuredApiPaths.INCONNECT_TEMPLATES}?${qs}`,
        reactQueryOptions
    );
};

export default useInconnectTemplates;
